import { autoinject } from "aurelia-dependency-injection";
import { backboneModelProperties } from "../../decorators/backbone-properties";
import { prop } from "../../decorators/property";
import { UserSettingsModel } from "./user-settings";
import { SourceLinkSettingsModel } from "./source-link-settings";

export enum Sections {
    MENU,
    JURISDICTIONS,
    SOURCELINKS,
    SEARCH_SETTINGS
}

@backboneModelProperties({
    relations: [{
        type: Backbone.One,
        key: "UserSettings",
        relatedModel: UserSettingsModel
    },
    {
        type: Backbone.One,
        key: "SourceLinkSettings",
        relatedModel: SourceLinkSettingsModel
    }],
    defaults: {
        Open: false,
        Section: Sections.MENU,
        SourceLinkSettings: null,
        UserSettings: null
    }
})
@autoinject
export class SettingsModel extends Backbone.AssociatedModel {

    @prop() public Open: boolean;
    @prop() public Loading: boolean;
    @prop() public Section: Sections;
    @prop() public UserSettings: UserSettingsModel;
    @prop() public SourceLinkSettings: SourceLinkSettingsModel;

    constructor(userSettings: UserSettingsModel,
                public sourceLinkSettingsModel: SourceLinkSettingsModel) {
        super();
        this.UserSettings = userSettings;
        this.SourceLinkSettings = sourceLinkSettingsModel;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/settings/models/settings.ts